module.exports = __webpack_public_path__ + "img/53.d4abe8df.png";